<template>
  <div class="selected-history-version">
    <div class="spinner-container" v-if="isLoading">
      <b-spinner />
    </div>
    <div v-else>
      <div class="version-header">
        <p class="version-name">
          {{ `${$t("portfolioManager.portfolioLifecycle.versionFrom")} `
          }}{{ version.date | formatDate }}
          <span class="rebalance-icon" v-if="version.rebalance">R</span>
        </p>
        <close-icon @click="setSelectedHistoryVersion(null)" />
      </div>
      <p class="version-section-heading">
        <span>{{ $t("portfolioManager.portfolioLifecycle.properties") }}</span>
      </p>
      <div class="version-measures">
        <version-measure
          v-for="measure in arrayMeasures"
          v-bind:key="measure.translateKey"
          v-bind="measure"
        />
      </div>
      <p class="version-section-heading">
        <span>{{ $t("portfolioManager.portfolioLifecycle.assets") }}</span>
      </p>
      <version-assets-table
        :portfolio="version.portfolio_input.custom_portfolio"
        :cashReserve="version.portfolio_input.cash_reserve"
      />
    </div>
  </div>
</template>

<script>
import CloseIcon from "vue-material-design-icons/Close";
import VersionAssetsTable from "./tables/VersionAssetsTable.vue";
import VersionMeasure from "./VersionMeasure.vue";
import { mapMutations } from "vuex";
export default {
  name: "selected-history-version",
  components: {
    CloseIcon,
    VersionMeasure,
    VersionAssetsTable,
  },
  props: {
    isLoading: Boolean,
    version: Object,
  },
  methods: {
    ...mapMutations("portfolioManagerStore", ["setSelectedHistoryVersion"]),
  },
  computed: {
    arrayMeasures() {
      return Object.entries(this.version.portfolio_output.custom_portfolio).map(
        ([key, value]) => ({
          translateKey: key,
          value,
        })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.selected-history-version {
  @include dps-box;
  .version-header {
    color: $primaryColor;
    font-size: $m-font;
    font-weight: 500;
    margin-bottom: toRem(0);
    padding-bottom: toRem(30);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .close-icon {
      cursor: pointer;
    }
    .version-name {
      margin-bottom: 0;
      display: flex;
      align-items: center;
    }
    .rebalance-icon {
      margin-left: toRem(10);
      font-weight: 700;
      font-size: 13px;
      color: $primaryColor;
      border: 1px solid $primaryColor;
      border-radius: 50%;
      width: toRem(23);
      height: toRem(23);
      display: inline-block;
      text-align: center;
    }
  }
  .version-section-heading {
    color: $subtleText;
    font-size: $s-font;
    margin-bottom: toRem(19);
    font-weight: 700;
    border-bottom: 1px solid #d2d2d2;
    position: relative;
    span {
      background-color: white;
      position: absolute;
      left: 0;
      bottom: -1px;
      padding-right: 2px;
    }
  }
  .version-measures {
    display: flex;
    flex-direction: column;
    margin-bottom: toRem(30);
  }
  .spinner-container {
    width: 100%;
    min-width: 385px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>